import { OreButton, OreStack, OreTooltip, SvgArrowLeft } from '@edenredespana/oreneta'
import { useFormContext } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { AutoEnrollmentTranslation } from '@/AutoEnrollment/ui/autoEnrollmentTranslation'
import { useAutoEnrollment } from '@/AutoEnrollment/ui/context'
import { Step3Form } from '@/AutoEnrollment/ui/hooks'
import { formTranslation } from '@/Shared/ui/sharedTranslation'

export const Step3Actions = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleSubmit } = useFormContext<Step3Form>()

  const {
    saveStep3,
    previousStep,
    documents: { dowloadedDocuments },
  } = useAutoEnrollment()

  const signButton = (
    <OreButton
      data-testid="saveStepThree"
      category={'primary'}
      onClick={handleSubmit(saveStep3)}
      disabled={
        !dowloadedDocuments
          .filter(d => d.mustBeSigned === true)
          .every(d => d.signed === true)
      }
    >
      {t(AutoEnrollmentTranslation.productsConditions.signDocuments.signButton.label)}
    </OreButton>
  )

  return (
    <OreStack space="large" direction="row" placeContent="space-between">
      <OreButton category={'tertiary'} icon={<SvgArrowLeft />} onClick={previousStep}>
        {t(formTranslation.common.buttons.back)}
      </OreButton>
      {!dowloadedDocuments
        .filter(d => d.mustBeSigned === true)
        .every(d => d.signed === true) ? (
        <OreTooltip
          text={t(
            AutoEnrollmentTranslation.productsConditions.signDocuments.signButton
              .disabled,
          )}
          placement="top"
        >
          {signButton}
        </OreTooltip>
      ) : (
        signButton
      )}
    </OreStack>
  )
}
